module.exports = __webpack_public_path__ + "static/smart-lists-34f2e84b64efa2043491e306e61ba560.svg";